(ns teamoesterreich.admin-mode.event-alarm.detail.alarm-stepper
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [goog.json :as json]
            [clojure.string :as str]
            [teamoesterreich.util.log :as log]

            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.data.eventAlarm :as d-eventAlarm]

            [teamoesterreich.admin-mode.actions :as a]

            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]


            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
            [reagent-material-ui.icons.alarm :refer [alarm]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            ))




(defonce BUTTON_GRID {:item true :xl 2 :md 3 :xs 6})

(defn get-it []
  (let [!st (r/atom {:tab 0})
        !show-alarm? (r/cursor !st [:show-alarm? false])]
    (fn []
      (let [!ws-update-lock (r/cursor store/app-state [:ws-update-lock])
            !alarm (r/cursor store/app-state [:selected-alarm])
            !list-loaded? (r/cursor store/app-state [:event :event-alarm-list-state :loaded])
            !event-detail-loaded? (r/cursor store/app-state [:alarm-detail-loaded])
            alarm-status (:eventAlarm-status @!alarm "prepare")
            alarm-step (case alarm-status
                         "prepare" 0
                         "send" 1
                         "close" 3
                         0)
            warn-text (str
                        (when (< (:_eventAlarm-alarmable @!alarm) 1) "Keine `ZU ALARMIEREN`, ")
                        (when (< (count (str (:eventAlarm-name @!alarm ""))) 1) "Name fehlt, ")
                        (cond
                          (= (:eventAlarm-channel @!alarm "") "")
                          "Option fehlt, "
                          (and (= (str/trim (:eventAlarm-mailBody @!alarm "")) "")
                               (or (= (:eventAlarm-channel @!alarm "") "email")
                                   (= (:eventAlarm-channel @!alarm "") "pushOrEmail")
                                   (= (:eventAlarm-channel @!alarm "") "pushOrSmsAndEmail")))
                          "Email Text fehlt, "
                          (and (= (str/trim (:eventAlarm-mailSubject @!alarm "")) "")
                               (or (= (:eventAlarm-channel @!alarm "") "email")
                                   (= (:eventAlarm-channel @!alarm "") "pushOrEmail")
                                   (= (:eventAlarm-channel @!alarm "") "pushOrSmsAndEmail")))
                          "Email Betreff fehlt, "
                          (and (= (str/trim (:eventAlarm-smsText @!alarm "")) "")
                               (or (= (:eventAlarm-channel @!alarm "") "sms")
                                   (= (:eventAlarm-channel @!alarm "") "pushOrSms")
                                   (= (:eventAlarm-channel @!alarm "") "pushOrSmsAndEmail")))
                          "SMS Text fehlt, "
                          (and (= (str/trim (:eventAlarm-pushText @!alarm "")) "")
                               (or (= (:eventAlarm-channel @!alarm "") "push")
                                   (= (:eventAlarm-channel @!alarm "") "pushOrSms")
                                   (= (:eventAlarm-channel @!alarm "") "pushOrEmail")
                                   (= (:eventAlarm-channel @!alarm "") "pushOrSmsAndEmail")))
                          "Push Text fehlt, "

                          ))
            ]

        [mui/card {}

         [are-you-sure-modal/are-you-sure-modal !show-alarm? "Jetzt alarmieren? Sendet an alle `ZU ALARMIEREN` die noch nicht alarmiert wurden!" "Jetzt alarmieren"
          (fn []
            (when (not= (:eventAlarm-status @!alarm) "send")
              (d-eventAlarm/>alarm-save (:eventAlarm-uuid @!alarm) {:eventAlarm-status "send"} (fn [data] (reset! !event-detail-loaded? false))))
            (d-eventAlarm/>alarm-send-alarm (:eventAlarm-uuid @!alarm)))]

         [:h3 "Alarmierung `" (:eventAlarm-name @!alarm) "`"
          [ws-event-sync-component/ws-event-reload !event-detail-loaded? :eventAlarm (:eventAlarm-uuid @!alarm) !ws-update-lock]
          ]
         [mui/stepper {:active-step alarm-step}
          [mui/step {
                     :key "Step1"
                     }
           [mui/step-label "Erstellen"]]

          [mui/step {
                     :key "Step2"
                     }
           [mui/step-label "Alarmierung"]]

          [mui/step {
                     :key "Step4"
                     }
           [mui/step-label "Abgeschlossen"]]
          ]
         (when (and (= alarm-status "prepare"))
           [mui/button {:variant   "outlined" :color "secondary"
                        :title     "Senden an alle"
                        :disabled  (not= warn-text "")
                        :startIcon (r/as-element [keyboard-arrow-right])
                        :onClick   #(reset! !show-alarm? true)
                        }
            "Jetzt Alarmieren"])
         (when (and (= alarm-status "send"))
           [mui/button {:variant   "outlined" :color "primary"
                        :title     "Senden an alle"
                        :disabled  (not= warn-text "")
                        :startIcon (r/as-element [alarm])
                        :onClick   #(reset! !show-alarm? true)
                        }
            "Nicht alarmierte alarmieren"])                 ; Voraussetzung: Texte, min user 1 alarmierbar

         (when (= alarm-status "send")
           [mui/button {:variant   "outlined" :color "secondary"
                        :title     "Alarmierung  abgeschlossen"
                        :startIcon (r/as-element [keyboard-arrow-right])
                        :style     {:margin-left "15px"}
                        :onClick   (fn [] (d-eventAlarm/>alarm-save (:eventAlarm-uuid @!alarm) {:eventAlarm-status "close"} (fn [data] (reset! !event-detail-loaded? false))))
                        }
            "Abschliessen"])                                ; Warnung wollen sie wirklich
         (when (= alarm-status "close")
           [mui/button {:variant   "outlined"
                        :title     "Nur Superuser"
                        :startIcon (r/as-element [keyboard-arrow-left])
                        :style     {:color "orange" :margin-left "15px"}
                        :onClick   (fn [] (d-eventAlarm/>alarm-save (:eventAlarm-uuid @!alarm) {:eventAlarm-status "send"} (fn [data] (reset! !event-detail-loaded? false))))}
            "Öffnen (Superuser)"])                          ; Warnung wollen sie wirklich
         (when (= alarm-status "send")
           [mui/button {:variant   "outlined"
                        :title     "Nur Superuser"
                        :startIcon (r/as-element [keyboard-arrow-left])
                        :style     {:color "orange" :margin-left "15px"}
                        :onClick   (fn [] (d-eventAlarm/>alarm-save (:eventAlarm-uuid @!alarm) {:eventAlarm-status "prepare"} (fn [data] (reset! !event-detail-loaded? false))))}
            "Erstellen (Superuser)"])

         (when (not= alarm-status "send")
           [mui/button {:variant   "outlined"
                        :title     "Nur Superuser"
                        :startIcon (r/as-element [delete-forever])
                        :style     {:color "orange" :margin-left "15px"}
                        :onClick   (fn [] (d-eventAlarm/>alarm-delete (:eventAlarm-uuid @!alarm) (fn [_] (reset! !list-loaded? false) (a/set-page :event-alarm))))
                        }
            "Löschen (Superuser)"])

         [:br]
         [:span {:style {:color "red"}}
          [:br]
          [:br]
          warn-text

          [:br]
          [:br]
          ]
         ]
        ))))
















